module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "buildings"
    }
  }, [_c('el-row', {
    staticClass: "headLine"
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "command": _vm.clickDropdown
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small"
    }
  }, [_vm._v("\n                    批量操作"), _c('i', {
    staticClass: "el-icon-arrow-down el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    attrs: {
      "command": "del"
    }
  }, [_vm._v("删除")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 20
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "状态",
      "clearable": "",
      "size": "small"
    },
    on: {
      "change": _vm.statusChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.options2), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), _c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": "标题搜索",
      "size": "small"
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.search
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-696ceb30"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/cms/message/platform_message/list/index.vue
// module id = 1514
// module chunks = 1